import { Checkbox, Flex } from '@percent/lemonade'
import { SubmitNominationFormPayload } from '@percent/product-nomination-form/api/nominationForm/nominationForm.types'
import { usePartnerConfig } from '@percent/product-nomination-form/hooks'
import { FormEvent, useCallback } from 'react'
import { FieldArrayWithId, useFormContext, useWatch } from 'react-hook-form'

export const ConfigurationList = ({
  nominee,
  nomineeIndex,
}: {
  nominee: FieldArrayWithId<SubmitNominationFormPayload, 'nominees', 'id'>
  nomineeIndex: number
}) => {
  const { setValue, control } = useFormContext<SubmitNominationFormPayload>()
  const { partnerConfig } = usePartnerConfig()

  const validationSubmissionConfigurationIds = useWatch({
    control,
    name: `nominees.${nomineeIndex}.validationSubmissionConfigurationIds`,
  })

  const handleConfigurationChange = useCallback(
    (configurationId: string) => (event: FormEvent<HTMLInputElement>) => {
      const isChecked = event.currentTarget.checked
      const idsList = isChecked
        ? [...validationSubmissionConfigurationIds, configurationId]
        : validationSubmissionConfigurationIds.filter(
            (id) => id !== configurationId
          )

      setValue(
        `nominees.${nomineeIndex}.validationSubmissionConfigurationIds`,
        idsList,
        {
          shouldValidate: true,
        }
      )
    },
    [nomineeIndex, validationSubmissionConfigurationIds, setValue]
  )

  return (
    <Flex gap={24} wrap="wrap">
      {partnerConfig?.configuration.allowedConfigurations.map(
        (configuration, configIndex) => (
          <Checkbox
            key={nominee.id + nomineeIndex + configuration.configurationId}
            label={configuration.configurationName}
            value={configuration.configurationId}
            variant="default"
            active={validationSubmissionConfigurationIds.includes(
              configuration.configurationId
            )}
            name={`nominees.${nomineeIndex}.validationSubmissionConfigurationIds.${configIndex}`}
            onChange={handleConfigurationChange(configuration.configurationId)}
          />
        )
      )}
    </Flex>
  )
}
